import React from 'react'

const Tags = ({label, bgColor}) => {
    const style = {
        backgroundColor: bgColor ? bgColor : `var(--${label}-clr)`,
        color: 'white',
        padding: '.35em 1em',
        fontSize: 'var(--small-fz)',
        borderRadius: 50,
        width: 'max-content',
        height: 'max-content',
        zIndex: 999
    }
    return (
        <div className="tag" style={style}>
            #{label}
        </div>
    )
}

export default Tags
